// extracted by extract-css-chunks-webpack-plugin
module.exports = {"info-icon":"custom-svg__info-icon___1YfSi","infoIcon":"custom-svg__info-icon___1YfSi"};
    if(module.hot) {
      // 1787101896183
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  